import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/faq/complaints')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
